import React, { useEffect } from "react";
import '../../screens/Jobs/jobs.css';
import TopNavbar from '../../components/Nav/TopNavbar';
import Footer from '../../components/Sections/Footer/Footer';
import cp_header from '../../assets/jobs/CP_Header.png'
import e1 from '../../assets/jobs/apple.png';
import e2 from '../../assets/jobs/e2.png';
import e3 from '../../assets/jobs/e3.png';
import google from '../../assets/jobs/google.png';
import intel from '../../assets/jobs/intel.png';
import apple from '../../assets/jobs/apple.png';
import frame from '../../assets/jobs/frame.png'
import frame2 from '../../assets/jobs/frame2.png';
import { useNavigate } from "react-router-dom";


export default function Jobs() {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const jobData = [
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: google,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: apple,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: google,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: apple,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: google,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: apple,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
        {
            title: 'Software Engineer',
            type: 'FULL-TIME',
            salary: '$60,000 - $80,000',
            company: 'TechCorp',
            logo: intel,
            location: 'Karachi',
            applicants: 30,
            applicantImages: [e1, e2, e3]
        },
    ];
    return (
        <>
            <TopNavbar />
            <div className="container-fluid p-0 bg_purple">
                <div className={`row m-auto d-flex section1_banner_container bg_purple `}
                    style={{
                        backgroundImage: `url(${cp_header})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        width: '100%',
                    }}>
                    <div className="col-12 col-md-12 col-lg-12 p-0 pb-5 pt-5 "
                        style={{
                            backgroundImage: `url(${frame2})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }} >
                        <div className=" d-flex flex-column justify-content-center align-items-center text-center px-3 py-5 my-5"
                            style={{
                                position: "relative",
                                zIndex: 2,
                            }}>
                            <h2 className={`text-white pt-1 pl-sm-2 banner_heading `}>JOBS</h2>
                            <div className="row justify-content-center">
                                <div className="col-lg-12"
                                    style={{
                                        marginTop: "13px",
                                    }}>
                                    <span className={`banner_paragraph text-white my-4`}>LOREM IPSUM LOREM IPSUM LOREM IPSUM</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        backgroundImage: `url(${frame})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        // width: '100%',
                    }}>
                    <div className="container-fluid pt-4"
                        style={{
                            backgroundImage: `url(${frame})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            // width: '100%',
                        }}>
                        <div className="pt-5 pl-2 header" >KARACHI JOB OPENINGS</div>
                        <div className="row py-5 pl-2">
                            {jobData.map((job, index) => (
                                <div key={index} className="col-12 col-md-6 col-lg-3 col-xl-3 pb-4" onClick={() => navigate('/JobListing') }>
                                <div className="job-card">
                                    <h5 className="card_title">{job.title}</h5>
                                    <div className="row px-2">
                                        <span
                                            className={`badge m-1 ${job.type === 'PART-TIME' ? 'part-time-badge' : 'full-time-badge'}`}
                                            style={{
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                fontFamily: '"Barlow", sans-serif',
                                            }}
                                        >
                                            {job.type}
                                        </span>
                                        <p className="salary pt-1">Salary: {job.salary}</p>
                                    </div>
                                    <div className="d-flex align-items-center py-3">
                                        <img
                                            alt={job.company}
                                            className="company-logo"
                                            height="36"
                                            src={job.logo}
                                            width="40"
                                        />
                                        <div className="ms-2 pl-2">
                                            <p
                                                className="mb-0"
                                                style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Barlow, sans-serif' }}
                                            >
                                                {job.company}
                                            </p>
                                            <p
                                                className="mb-0 text-muted"
                                                style={{ fontSize: '13px', fontFamily: 'Barlow, sans-serif' }}
                                            >
                                                <i className="fas fa-map-marker-alt"></i> {job.location}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="applicants mt-2 d-flex align-items-center">
                                        {job.applicantImages.map((img, idx) => (
                                            <img key={idx} alt={`Applicant ${idx + 1}`} height="20" src={img} width="20" />
                                        ))}
                                        <span className="pl-3 jobsapplicants">{job.applicants}+ applicants</span>
                                    </div>
                            
                                    <div className="d-flex flex-column flex-md-row justify-content-between mt-3">
                                        <button className="btn btn-view-detail mb-2 mb-md-0">View details</button>
                                        <button
                                            className="btn"
                                            style={{ backgroundColor: '#160A54', color: 'white' }}
                                        >
                                            Apply now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );


}


